// src/pages/UnderConstructionPage.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools, faHome, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const UnderConstructionPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 p-6 text-center">
      <div className="text-yellow-500 text-6xl mb-4 animate-bounce">
        <FontAwesomeIcon icon={faTools} />
      </div>

      <h1 className="text-3xl font-bold text-gray-800 mb-4">Page Under Construction</h1>
      <p className="text-gray-600 mb-6">
        We're working hard to bring this page to life. Please check back later!
      </p>

      <img
        src="/assets/under-construction.png"
        alt="Under construction"
        className="w-full max-w-md rounded-lg shadow-lg mb-8"
      />

      <div className="flex gap-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>

        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          <FontAwesomeIcon icon={faHome} />
          Home
        </button>
      </div>
    </div>
  );
};

export default UnderConstructionPage;